let currentPage = 1;
$('.btn-loadmore').on('click', function() {
  currentPage++;

  $.ajax({
    type: 'POST',
    url: '/psychiatrisch/wp-admin/admin-ajax.php',
    data: {
      action: 'post_load_more',
      paged: currentPage,
    },
    success: function (res) {
      if (res) {
        $('.news-container').append(res);
      } else {
        $('.btn-loadmore').hide();
      }
    },
  });
});



// WEBPACK FOOTER //
// ./scripts/ajax/query-post.js